module.exports = __webpack_public_path__ + "img/img-19.54c60979.png";